<header>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
          <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
            <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
              &nbsp;&nbsp;Español
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          GoogleAssistantPrivacyLitigation.com
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
        </span>
      </div>
    </div>
  </div>
  <br />
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>


</header>
<div class="container" style="border:1px solid #bebaba">

  <br />
  <div class="text-center" style="font-weight:bold">

    This official website is maintained by the Claims Administrator
    <br />
    <br />
    <br />
  </div>
  <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align: center; font-weight: bold">
    <h3>Court Documents</h3>
  </div>
  <div class="row indentContent">
    <div class="col-md-12">
      <p style="font-weight:bold">Please use the links below to view the Notice.</p>

      <ul>
        <li>
          <a href="../../../assets/documents/141-4th Amended Consol Complaint.pdf"
             target="_blank">
            Fourth Amended Consolidated Class Action Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/549- Plaintiff Motion for Prelim Approval.pdf"
             target="_blank">
            Plaintiffs’ Unopposed Motion for Preliminary Approval of Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/549-1-Levis Comite ISO Motion for Prelim Approval.pdf"
             target="_blank">
            Joint Declaration of Christian Levis and Erin Green Comite in Support of Plaintiffs’ Unopposed Motion for Preliminary Approval of Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/549-2-Exhibit 1-Redacted Settlement Agreement.pdf"
             target="_blank">
            Stipulation and Agreement of Settlement Redacted Version
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/549-2E- Plan of Allocation.pdf"
             target="_blank">
            Plan of Allocation
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/560.pdf"
             target="_blank">
            Amended Order Granting Plaintiffs’ Motion for Preliminary Approval of Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/566-Plaintiff Motion for Fees, Awards, Exp and Svc Award.pdf"
             target="_blank">
            Plaintiffs’ Counsel’s Notice of Motion and Motion for Attorneys’ Fees and Expenses and Plaintiffs’ Application for Service Awards; Memorandum of Points and Authorities in Support Thereof
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/566-1-Jt Dec ISO Motion for Fees, Exp and Srvc Awards.pdf"
             target="_blank">
            Joint Declaration of Erin Green Comite and Christian Levis in Support of Plaintiffs’ Counsel’s Motion for Attorneys’ Fees and Expenses and Plaintiffs’ Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/567_Final Approval Motion.pdf"
             target="_blank">
            Plaintiffs' Notice of Motion and Motion for Final Approval of Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/567_1-Teichmiller Declaration.pdf"
             target="_blank">
            Declaration of Rochelle J. Teichmiller on Implementation of Notice Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/574_09172026_Plaintiff's Reply ISO Approval and Motion for Fees, Exp, Awards.pdf"
             target="_blank">
            Plaintiffs’ Reply in Support of (I) Motion for Final Approval of Class Action Settlement and (II) Motion for Attorneys’ Fees, Expenses, and Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/574-1_09172026_Supplemental Declaration of Rochelle Teichmiller.pdf"
             target="_blank">
            Supplemental Declaration of Rochelle J. Teichmiller
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/584-Google Assistant_Final Approval and Fees Order.pdf"
             target="_blank">
            Order Granting Plaintiffs’ Motion for Final Approval of Class Action Settlement; Granting in Part and Denying in Part Class Counsel’s Motion for Attorneys’ Fees and Expenses; and Overruling Objections
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/586_Final Judgement.pdf"
             target="_blank">
            Final Judgment
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
